module.exports = __webpack_public_path__ + "static/media/07_tn.a827aec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/thumbnails/07_tn.jpg
// module id = 437
// module chunks = 0